module.exports = __webpack_public_path__ + "static/media/search.1b744ddf.jpg";